import styled from 'styled-components';

export const ModalBodyFieldContainer = styled.div`
  margin: 1rem 0;
`;
export const ModalBodyHeader = styled.div`
  padding-right: 1rem;
  flex: 1 0 70%;
`;
export const ModalBodyResponse = styled.div`
  margin: 1rem 0;
`;
export const AgentTokenContainer = styled.div<{
  agentToken: string;
}>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  .agent-header {
    flex: 1 0 100%;
  }
  .agent-token-field {
    flex: 1 0 60%;
  }
  .agent-token-button {
    flex: 1 0 30%;
  }
  .copy-icon {
    flex: 1 0 10%;
    cursor: ${({ agentToken }) => (agentToken ? 'pointer' : 'not-allowed')};
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  gap: 0.75rem;
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 1rem;

  .provision-field {
    width: 100%;
  }
`;
